import { render, staticRenderFns } from "./Deletion.vue?vue&type=template&id=b1c889c8&scoped=true&"
import script from "./Deletion.vue?vue&type=script&lang=js&"
export * from "./Deletion.vue?vue&type=script&lang=js&"
import style0 from "./Deletion.vue?vue&type=style&index=0&id=b1c889c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c889c8",
  null
  
)

export default component.exports